import React, { PureComponent } from 'react';

import './SearchPresets.styl';

class SearchPresets extends PureComponent {
  render() {
    const { presets, title } = this.props;

    if (!presets || presets.length === 0) {
      return null;
    }

    return (
      <div className="search__presets">
        {title && <div className="search__presets-label">{title}</div>}
        <div className="search__presets-list">
          {this.props.presets.map(p => (
            <div
              key={`search__preset_${p.name}`}
              className="search__presets-preset"
              onClick={() => this.props.onClick(p)}
            >{p.name}</div>
          ))}
        </div>
      </div>
    );
  }
}

export default SearchPresets;
